import axios from "axios";
import { Message } from "element-ui";
import { getToken, hasToken, setToken, removeToken } from "./storage";
import { SERVERURL } from "./config";

// 设置根路径
const Request = axios.create({
  baseURL: SERVERURL,
  timeout: 6000,
});
// ---------- 核心状态变量 ----------
// 是否正在刷新token的标志
let isRefreshing = false;
// 等待队列，存储需要重试的请求配置和对应的resolve/reject
let failedQueue = [];

// 处理等待队列的函数
const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      // 如果刷新成功，用新token重试请求
      prom.resolve(token);
    }
  });
  // 清空队列
  failedQueue = [];
};
// 请求拦截器
Request.interceptors.request.use((config) => {
  if (hasToken()) {
    config.headers["Authorization"] = "Bearer " + getToken();
  }
  return config;
});
// 响应拦截器
Request.interceptors.response.use(
  (res) => {
    if (res.data.code != 1) {
      Message({
        message: res.data.msg,
        type: "error",
      });
      return res;
    }
    return res;
  },
  async (error) => {
    const originalRequest = error.config;
    // 1. 如果错误不是401，或者已经重试过（避免死循环），直接抛出错误

    if (error.response?.status !== 401 || originalRequest._retry) {
      if (error.response?.status == 429) {
        Message({
          message: "操作过于频繁，请3600秒后再试",
          type: "error",
        });
      } else {
        Message({
          message: error,
          type: "error",
        });
      }
      removeToken();
      return Promise.reject(error);
    }
    // 2. 标记当前请求已经尝试过刷新（防止无限重试）
    originalRequest._retry = true;
    // 3. 如果当前没有正在刷新token，则执行刷新操作
    if (!isRefreshing) {
      isRefreshing = true;

      try {
        // 获取refresh_token（通常存在localStorage或httpOnly cookie中）
        const refreshToken = getToken();

        // 调用刷新token的接口（注意：这个接口本身不能带过期的access_token）
        // document.cookie = `Refresh-Token=${refreshToken}; path=/; max-age=3600`;
        const response = await axios.post(
          "https://dt.gyycbj.com/api/user/refresh-token",
          {},
          {
            withCredentials: true,
          },
        );

        // 假设新token在 response.data.access_token 中
        const newAccessToken = response.data.data.accessToken;
        console.log("newAccessToken ", newAccessToken);

        // 保存新token
        setToken(newAccessToken);

        // 刷新成功，处理等待队列：让队列中的所有请求重试
        processQueue(null, newAccessToken);

        // 用新token重新请求原始接口
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return Request(originalRequest);
      } catch (err) {
        // 刷新token失败（如refresh_token也过期了），清空本地token并跳转登录页
        let timer = setTimeout(() => {
          localStorage.clear();
          location.reload();
        }, 2000);
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    } else {
      // 4. 如果正在刷新token，将当前请求放入队列等待
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      })
        .then((token) => {
          // 拿到新token后，更新原请求的header并重试
          originalRequest.headers["Authorization"] = `Bearer ${token}`;
          return Request(originalRequest);
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    }
  },
);

export default Request;
